/**
 * Blue Dot Indicator Component
 * Shows a blue dot next to menu items for first-time users
 */

import React, { useEffect, useState } from 'react';
import { useTutorial } from '@/context/TutorialContext';

interface BlueDotProps {
  id: string;
  label: string;
  onClick?: () => void;
}

const BlueDot: React.FC<BlueDotProps> = ({ id, label, onClick }) => {
  const { dismissBlueDot, onboardingState } = useTutorial();
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    if (onboardingState?.dismissedDots.includes(id)) {
      setIsVisible(false);
    }
  }, [id, onboardingState?.dismissedDots]);

  const handleDismiss = (e: React.MouseEvent) => {
    e.stopPropagation();
    dismissBlueDot(id);
    setIsVisible(false);
  };

  if (!isVisible || !onboardingState?.preferences?.showDots) {
    return null;
  }

  return (
    <div className="relative inline-block">
      {/* Blue dot indicator */}
      <div
        className="absolute -top-2 -right-2 w-4 h-4 bg-blue-500 rounded-full shadow-lg animate-pulse cursor-pointer hover:bg-blue-600 transition-colors"
        onClick={handleDismiss}
        title={`Learn about ${label}`}
      >
        {/* Inner pulsing circle */}
        <div className="absolute inset-1 bg-blue-400 rounded-full animate-ping opacity-75"></div>
      </div>

      {/* Tooltip on hover */}
      <div className="absolute bottom-full left-0 mb-2 px-2 py-1 bg-gray-900 text-white text-xs rounded whitespace-nowrap opacity-0 hover:opacity-100 transition-opacity pointer-events-none z-50">
        <span>✨ New: {label}</span>
        <div className="absolute top-full left-0 w-full h-2"></div>
      </div>
    </div>
  );
};

export default BlueDot;
